// extracted by mini-css-extract-plugin
module.exports = {"card":"_4Yhxut+fv3k6+K64Sn4uuw==","btnI":"QcJrzJdEn2O7TXbBqJqiOg==","infoCard":"-0ZwoU2lbzHYOFzpuAdpOA==","infoCard2":"U4ad5sWWoVA8j4csrbVrcQ==","h4":"qHAsvgdg7js5qtTwNb0dFA=="};